// app/javascript/modules/admissoes/dependentes_docs.js

export function initDependentesDocs($form, h) {
  const { hide, show, parseDateSmart, calcAge } = h
  const ns = ".admissaoDependentes"

  // --- Controle de "Possui Dependentes?" ---

  // Campos do primeiro dependente que se tornam obrigatórios quando possui_dependentes = "Sim"
  const CAMPOS_DEPENDENTE_REQUIRED = [
    "#params_nome_dependente",
    "#params_data_nascimento_dependente",
    "#params_grau_parentesco_dependente",
  ]

  function setRequiredDependente(required) {
    CAMPOS_DEPENDENTE_REQUIRED.forEach(sel => {
      const $el = $form.find(sel)
      if (!$el.length) return
      if (required) {
        $el.attr("required", "required").attr("aria-required", "true")
      } else {
        $el.removeAttr("required").removeAttr("aria-required")
      }
    })
  }

  function syncPossuiDependentes() {
    const val = $form.find('input[name="params[possui_dependentes]"]:checked').val()
    const $conteudo = $form.find("#secao-dependentes-conteudo")

    if (val === "Sim") {
      $conteudo.show()
      setRequiredDependente(true)
      // re-avalia docs do primeiro dependente
      syncDocsPrimeiroDependente()
    } else {
      $conteudo.hide()
      setRequiredDependente(false)
      // esconde docs do primeiro dependente
      $form.find("#docs-primeiro-dependente").hide()
    }
  }

  // --- Docs do primeiro dependente (Filho ou Filho PCD, com docs condicionais por idade) ---

  function syncDocsPrimeiroDependente() {
    const possuiDep = $form.find('input[name="params[possui_dependentes]"]:checked').val()
    if (possuiDep !== "Sim") {
      $form.find("#docs-primeiro-dependente").hide()
      return
    }

    const grau = $form.find("#params_grau_parentesco_dependente").val()
    const isFilho = grau === "Filho" || grau === "Filho PCD"

    if (!isFilho) {
      $form.find("#docs-primeiro-dependente").hide()
      return
    }

    // Seção de docs sempre visível para filho
    $form.find("#docs-primeiro-dependente").show()

    const dn = parseDateSmart($form.find("#params_data_nascimento_dependente").val())
    const idade = dn ? calcAge(dn) : null

    // Cartão de vacina: até 6 anos
    $form.find("#docs-cartao-vacina-primeiro").toggle(idade !== null && idade <= 6)

    // Declaração escolar + Certidão escolar: 7 a 14 anos
    $form.find("#docs-declaracao-escolar-primeiro").toggle(idade !== null && idade >= 7 && idade <= 14)
    $form.find("#docs-certidao-escolar-primeiro").toggle(idade !== null && idade >= 7 && idade <= 14)
  }

  // --- Bind events ---

  $form.off(ns)
  $form.on(`change${ns}`, 'input[name="params[possui_dependentes]"]', syncPossuiDependentes)
  $form.on(`change${ns}`, "#params_grau_parentesco_dependente, #params_data_nascimento_dependente", syncDocsPrimeiroDependente)

  return {
    apply() {
      syncPossuiDependentes()
    },
    destroy() { $form.off(ns) }
  }
}
